var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhython(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1483 0.875C17.6611 0.875 18.8149 8.87399 18.8149 8.87399L18.8376 17.1613H36.4783V19.6475H11.8264C11.8264 19.6475 0 18.3079 0 36.9215C0 55.5306 10.3245 54.8721 10.3245 54.8721H16.4869V46.2351C16.4869 46.2351 16.1547 35.9338 26.6476 35.9338H44.1426C44.1426 35.9338 53.9732 36.0928 53.9732 26.4545V10.5178C53.9732 10.5178 55.4661 0.875 36.1483 0.875ZM26.42 6.44682C28.1745 6.44682 29.5945 7.86361 29.5945 9.61417C29.5945 11.3647 28.1745 12.7815 26.42 12.7815C26.0029 12.7821 25.5899 12.7006 25.2045 12.5416C24.819 12.3827 24.4689 12.1494 24.174 11.8552C23.8791 11.5609 23.6452 11.2115 23.4859 10.827C23.3266 10.4424 23.2449 10.0303 23.2455 9.61417C23.2455 7.86361 24.6655 6.44682 26.42 6.44682Z",
    fill: "url(#paint0_linear_384_2579)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5211 72.875C54.6659 72.875 53.5336 64.8757 53.5336 64.8757L53.5112 56.588H36.1973V54.1017H60.3904C60.3904 54.1017 72 55.4413 72 36.8293C72 18.2172 61.8667 18.8779 61.8667 18.8779H55.8184V27.513C55.8184 27.513 56.1445 37.8147 45.8459 37.8147H28.6749C28.6749 37.8147 19.0263 37.6558 19.0263 47.2944V63.2318C19.0263 63.2318 17.5611 72.875 36.5211 72.875ZM46.0693 67.303C45.6599 67.3036 45.2545 67.222 44.8762 67.0631C44.498 66.9041 44.1543 66.6708 43.8648 66.3765C43.5754 66.0823 43.3459 65.7329 43.1895 65.3483C43.0332 64.9638 42.953 64.5516 42.9536 64.1355C42.9536 62.3871 44.3472 60.9703 46.0693 60.9703C47.7913 60.9703 49.185 62.3848 49.185 64.1355C49.185 65.8884 47.7913 67.303 46.0693 67.303Z",
    fill: "url(#paint1_linear_384_2579)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_384_2579",
    x1: 6.99755,
    y1: 7.19154,
    x2: 42.9234,
    y2: 43.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387EB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#366994"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_384_2579",
    x1: 29.1372,
    y1: 29.8449,
    x2: 67.6913,
    y2: 66.1776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC331"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhython);
export default __webpack_public_path__ + "static/media/phython.4c87d7b19a4e792317a6f463eeeb1036.svg";
export { ForwardRef as ReactComponent };